// import React from "react";

const HeadlineTextTwo = ({ name, t }) => {
  switch (name) {
    case "Klimat":
      return t("Mer klimatdata");
    case "Social rättvisa":
      return t("Mer data om social rättvisa");
    case "Vatten":
      return t("Mer vattendata");
    case "Antibiotikaresistens":
      return t("Mer data om antibiotikaresistens");
    case "Transport":
      return t("Mer transportdata");
    case "Landanvändning":
      return t("Mer data om landanvändning");
    case "Bekämpningsmedel":
      return t("Mer data om bekämpningsmedel");
    case "Övergödning":
      return t("Mer data om övergödning");
    case "Barnarbete":
      return t("Mer data om barnarbete");
    case "Djurvälfärd":
      return t("Mer data om djurvälfärd");
    case "Arbetsförhållanden":
      return t("Mer data om arbetsförhållanden");
    case "Biologisk mångfald":
      return t("Mer data om biologisk mångfald");
    case "Jämlikhet":
      return t("Mer data om jämlikhet");
    case "Lokalbefolkning":
      return t("Mer data om lokalbefolkning");
    default:
      return t("Mer data");
  }
};

export default HeadlineTextTwo;
